<h1 class="raportti-header">Tase</h1>

@if (taseEnsin) {
  <div class="tulos-ensin">
    <app-button (click)="tulosEnsinClicked.emit()" actionId="Tulos ensin (näkymä)" additionalClass="report-btn tulos-ensin-button">
      <div>Tulos ensin</div>
    </app-button>
  </div>
}

@if (taseDataObservable | async; as data) {
  @if (!lataa()) {
    @if (data.e == 'a') {
      <div>Valittu päivämäärä ei ole millään Lemonatorista löytyvällä tilikaudella.</div>
    }
    @if (lastSucessfullyUpdated()) {
      <div class="gray-text" style="font-size: 11px; text-align: left; margin-left: 5px; margin-top: 16px; line-height: 13px">Päivitetty {{ lastSucessfullyUpdated() | ltimestamptime | async }}</div>
    }
    @if (data.c == 'c2') {
      <table class="report-table" (click)="handleClick($event, data)">
        <thead>
          <tr>
            <td></td>
            <td>{{ data.c1.e | lnumberpvml: 'fi' }}</td>
            <td>{{ data.c2.e | lnumberpvml: 'fi' }}</td>
            <td>Muutos</td>
          </tr>
        </thead>
        @for (row of data.r; track trackAccountRowByAccountNumberFn($index, row)) {
          <tbody>
            <tr [attr.data-tnro]="row.a" class="report-row-lvl-{{ row.l }} report-row-acc-nmbr-length-{{ row.a.length }}" [class.report-row-expanded]="row.e" [class.report-row-sum]="row.s">
              <td class="n">
                {{ row.n }}
                @if (row.showR) {
                  <span class="r-button" (click)="avaaReskontraValilehti(row.n, data.c1.e)"> R </span>
                }
                @if (row.poistotiedot) {
                  <span class="kirjanpito-raportit-poistotilin-tunniste" matTooltip="Automaattinen poistotili">A{{ row.poistotiedot.poistoprosentti }}</span>
                }
              </td>
              <td>{{ row.s1 | number: '1.2-2' }}</td>
              <td>{{ row.s2 | number: '1.2-2' }}</td>
              <td>{{ row.m | number: '1.2-2' }}</td>
            </tr>
            @if (row.e && row.d == undefined) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="4">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
              </tr>
            }
            @if (row.e && row.d) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="4">
                  <table>
                    <thead>
                      <tr>
                        <td>Laji</td>
                        <td>Tosite</td>
                        <td>Pvm</td>
                        <td>Selite</td>
                        <td>ALV</td>
                        <td>Debet</td>
                        <td>Kredit</td>
                        <td>Saldo</td>
                      </tr>
                      <tr class="alkusaldo">
                        <td></td>
                        <td></td>
                        <td colspan="2">Alkusaldo</td>
                        <td colspan="4" [attr.data-a]="row.a" class="ah" [class.blue-link-text]="row.o1">{{ row.o1 | number: '1.2-2' }}</td>
                      </tr>
                      <tr style="display: none">
                        <td colspan="8">
                          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        </td>
                      </tr>
                    </thead>
                    <tbody [attr.data-n]="row.n">
                      @for (d of row.d; track d; let i = $index) {
                        <tr [attr.data-i]="i" [class.laajennettu]="d.l">
                          <td [class.projekti-dot]="d.b" [class]="d.b ? 'a' + d.b : null">{{ d.ma }}</td>
                          <td [attr.data-n]="d.n">{{ d.n }}</td>
                          <td>{{ d.p | lnumberpvmlnarrow: 'fi' }}</td>
                          <td>
                            @if (d.a) {
                              <span class="blue-text space-after">{{ d.a }}</span>
                            }
                            @if (d.c) {
                              <span class="cursive-text space-after">{{ d.c }}</span>
                            }
                            {{ d.r }} {{ d.e }}
                          </td>
                          <td>{{ d.v }}</td>
                          <td>{{ d.d | number: '1.2-2' }}</td>
                          <td>{{ d.k | number: '1.2-2' }}</td>
                          <td>{{ d.s | number: '1.2-2' }}</td>
                        </tr>
                      }
                      <tr class="loppusaldo">
                        <td></td>
                        <td></td>
                        <td colspan="2">Yhteensä</td>
                        <td></td>
                        <td>{{ row.dds | number: '1.2-2' }}</td>
                        <td>{{ row.dks | number: '1.2-2' }}</td>
                        <td>{{ row.dss | number: '1.2-2' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    }
    @if (data.c == 'c1') {
      <table class="report-table" (click)="handleClick($event, data)">
        <thead>
          <tr>
            <td></td>
            <td>{{ data.c1?.e | lnumberpvml: 'fi' }}</td>
          </tr>
        </thead>
        @for (row of data.r; track trackAccountRowByAccountNumberFn($index, row)) {
          <tbody>
            <tr [attr.data-tnro]="row.a" class="report-row-lvl-{{ row.l }} report-row-acc-nmbr-length-{{ row.a.length }}" [class.report-row-expanded]="row.e" [class.report-row-sum]="row.s">
              <td class="n">
                {{ row.n }}
                @if (row.showR) {
                  <span class="r-button" (click)="avaaReskontraValilehti(row.n, data.c1.e)"> R </span>
                }
                @if (row.poistotiedot) {
                  <span class="kirjanpito-raportit-poistotilin-tunniste" matTooltip="Automaattinen poistotili">A{{ row.poistotiedot.poistoprosentti }}</span>
                }
              </td>
              <td>{{ row.s1 | number: '1.2-2' }}</td>
            </tr>
            @if (row.e && row.d == undefined) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="2">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
              </tr>
            }
            @if (row.e && row.d) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="2">
                  <table>
                    <thead>
                      <tr>
                        <td>Laji</td>
                        <td>Tosite</td>
                        <td>Pvm</td>
                        <td>Selite</td>
                        <td>ALV</td>
                        <td>Debet</td>
                        <td>Kredit</td>
                        <td>Saldo</td>
                      </tr>
                      <tr class="alkusaldo">
                        <td></td>
                        <td></td>
                        <td colspan="2">Alkusaldo</td>
                        <td colspan="4" [attr.data-a]="row.a" class="ah" [class.blue-link-text]="row.o1">{{ row.o1 | number: '1.2-2' }}</td>
                      </tr>
                      <tr style="display: none">
                        <td colspan="8">
                          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        </td>
                      </tr>
                    </thead>
                    @if (row.d.length > 0) {
                      <tbody [attr.data-n]="row.n">
                        @for (d of row.d; track d; let i = $index) {
                          <tr [attr.data-i]="i" [class.laajennettu]="d.l">
                            <td [class.projekti-dot]="d.b" [class]="d.b ? 'a' + d.b : null">{{ d.ma }}</td>
                            <td [attr.data-n]="d.n">{{ d.n }}</td>
                            <td>{{ d.p | lnumberpvmlnarrow: 'fi' }}</td>
                            <td>
                              @if (d.a) {
                                <span class="blue-text space-after">{{ d.a }}</span>
                              }
                              @if (d.c) {
                                <span class="cursive-text space-after">{{ d.c }}</span>
                              }
                              {{ d.r }} {{ d.e }}
                            </td>
                            <td>{{ d.v }}</td>
                            <td>{{ d.d | number: '1.2-2' }}</td>
                            <td>{{ d.k | number: '1.2-2' }}</td>
                            <td>{{ d.s | number: '1.2-2' }}</td>
                          </tr>
                        }
                        <tr class="loppusaldo">
                          <td></td>
                          <td></td>
                          <td colspan="2">Yhteensä</td>
                          <td></td>
                          <td>{{ row.dds | number: '1.2-2' }}</td>
                          <td>{{ row.dks | number: '1.2-2' }}</td>
                          <td>{{ row.dss | number: '1.2-2' }}</td>
                        </tr>
                      </tbody>
                    }
                  </table>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    }
  } @else {
    <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
  }
}
